enum DraggableImageOverlayType {
    Signature = 1
}

enum OverlayElementType {
    DraggableImage = 1, // Corresponds to the actual overlays on the front end the user can drag around.
    PrepositionedSignature = 2, // Signature is positioned by backend request handler
    PrepositionedPharmacyInfo = 3, // Pharmarcy info is positioned by backend request handler
    SignedPrintAuthorization = 4, // Alternate signature required by backend request handler
    InfoFaxReceiverContact = 5 // Fax info is positioned by backend request handler
}

class OverlayElement {
    public id: string;
    public overlayElementType: OverlayElementType;

    constructor(type: OverlayElementType, fields?: Partial<OverlayElement>) {
        Object.assign(this, fields);
        this.overlayElementType = type;
    }
}

export { DraggableImageOverlayType, OverlayElement, OverlayElementType };
